<template>
<div>

  <div class="biz-box top-border">
    <div class="biz-list">
      <ul class="">

        <li>
          <!-- <router-link :to="{ name: 'appointment',params: {type: 'tihuo'}}"> -->
          <div class="biz-item" @click="yuyue('tihuo')">
            <img :src="require('@/assets/images/tihuo-dingdan.png')" alt="">
            <p class="item-title">提货预约</p>
            <p class="item-desc"></p>
          </div>
          <!-- </router-link> -->
        </li>


        <li>
          <!-- <router-link :to="{ name: 'appointment',params: {type: 'xiehuo'}}"> -->
          <div class="biz-item" @click="yuyue('xiehuo')">
            <img :src="require('@/assets/images/xiehuo-dingan.png')" alt="">
            <p class="item-title">卸货预约</p>
            <p class="item-desc"></p>
          </div>
          <!-- </router-link> -->
        </li>

        <li>
          <router-link :to="{ name: 'orderlist'}">
            <div class="biz-item">
              <img :src="require('@/assets/images/orderlist.png')" alt="">
              <p class="item-title">我的订单</p>
              <p class="item-desc"></p>
            </div>
          </router-link>
        </li>

        <li>
          <router-link :to="{ name: 'vehicle',params: {type: 0}}">
            <div class="biz-item">
              <img :src="require('@/assets/images/vehicle.png')" alt="">
              <p class="item-title">我的车辆</p>
              <p class="item-desc"></p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'driver'}">
            <div class="biz-item">
              <img :src="require('@/assets/images/siji-beian.png')" alt="">
              <p class="item-title">驾驶员备案</p>
              <p class="item-desc"></p>
            </div>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'escort'}">
            <div class="biz-item">
              <img :src="require('@/assets/images/escort-beian.png')" alt="">
              <p class="item-title">押运员备案</p>
              <p class="item-desc"></p>
            </div>
          </router-link>
        </li>

      </ul>
    </div>
  </div>

</div>
</template>

<script>
import api from "@/fetch/api"
import {
  Dialog
} from 'vant'
export default {
  data() {
    return {
      xyState: 1,
      openid:'',
    }
  },
  created: function() {
    var that = this;
    var openid = that.$store.state.wx_info.openid;
    that.$data.openid = openid;
  },
  methods: {
    yuyue(type) {
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      api.getCns(openid).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          Dialog.confirm({
              message: '本人承诺本次预约所使用信息及上传的证件均真实有效，如有虚假，愿承担相关法律责任',
            })
            .then(() => {
              that.confirmCns();//type
              that.$router.push({
                name: 'appointment',
                params: {
                  type: type
                }
              })
            })
            .catch(() => {
              // on cancel
            });
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            //
          });
        }
      });


    },
    confirmCns() {//type
      var that = this;
      var openid = that.$store.state.wx_info.openid;
      var formData = JSON.stringify({
        openid: openid
      });

      api.createCns(formData).then(function(res) {
        var resData = JSON.parse(res);
        if (resData.respCode == "0") {
          //
        } else {
          Dialog.alert({
            message: resData.message,
          }).then(() => {
            //
          });
        }
      });
    },
  },

}
</script>

<style lang="scss" scoped>
.top-border{
  margin-top: 0.625rem;
}
.biz-box {
    //overflow: hidden;
    border-bottom: 1 solid #ececec;
    background: #ececec;
    .title {
        padding-top: 1rem;
        padding-bottom: 1rem;
        padding-left: 1rem;
        width: 100%;
        float: left;
        .bold-font {
            font-weight: bold;
            font-size: 1rem;
        }
    }
    .biz-list {
        width: 100%;
        .li-border {
            border-right: 1px solid #ececec;
            border-bottom: 1px solid #ececec;
        }

        li {
            width: 32.5%;
            float: left;
            display: inline;
            list-style-type: none;
            white-space: nowrap;
            border-left: 1px solid #ececec;
            border-bottom: 1px solid #ececec;
            .biz-item {
                background: #fff;
                text-align: center;
                padding-top: 1.25rem;
                //padding-bottom: 1rem;
                //line-height: 1.75;
                height: 6.5rem;
                .item-title {
                  padding-top: .5rem;
                    display: inline-block;
                    color: #101010;
                    font-weight: bold;
                    font-size: 1rem;
                }
                .item-desc {
                    //color: #BEC7D1;
                    color: #fff;
                    //font-size: 0.24rem;
                }
                img {
                    display: block;
                    position: relative;
                    width: 3.25rem;
                    height: 3.25rem;
                    margin: 0 auto;

                }
            }

        }
    }
}
</style>
